var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal_wrap", on: { click: _vm.onClose } }, [
    _c("div", { staticClass: "modal_container wrapper_body card" }, [
      _c("div", { staticClass: "card-header position-relative" }, [
        _c("h5", [
          _vm._v("Отправка сообщения "),
          _c("strong", [
            _vm._v(
              _vm._s(
                _vm.type === "supervisor"
                  ? "Контролер"
                  : _vm.type === "manager"
                  ? "Менеджеру"
                  : "Курьеру"
              )
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("i", {
          staticClass: "icon-fa icon-fa-close position-absolute close_btn",
          on: {
            click: function ($event) {
              return _vm.onClose(null, true)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _vm.type !== "manager"
                    ? [
                        _c("p", { staticClass: "mb-0" }, [
                          _vm._v("Шаблоны сообщений"),
                        ]),
                        _vm._v(" "),
                        _vm._l(
                          _vm.templates[_vm.type],
                          function (template, index) {
                            return _c(
                              "button",
                              {
                                staticClass: "btn btn-default mb-1",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    _vm.extra_message =
                                      _vm.templates[_vm.type][index]
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(template) +
                                    "\n              "
                                ),
                              ]
                            )
                          }
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  +_vm.data.status === 2
                    ? [
                        _c("p", [
                          _vm._v("Курьер: "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.data.courier?.name ?? "Не найден получатель"
                              )
                            ),
                          ]),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _vm.type !== "supervisor"
                  ? _c(
                      "div",
                      { staticClass: "alert alert-info" },
                      [
                        _c("pulse-loader", {
                          staticClass: "text-center",
                          attrs: {
                            loading: _vm.loading,
                            color: _vm.$constants.LOADING_COLOR,
                          },
                        }),
                        _vm._v(" "),
                        !_vm.loading && _vm.receivers
                          ? [
                              _c("h6", [_vm._v("Получатели:")]),
                              _vm._v(" "),
                              _vm._l(_vm.receivers, function (r) {
                                return _c(
                                  "div",
                                  { staticClass: "receiver" },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "(" +
                                          _vm._s(r.id) +
                                          ") " +
                                          _vm._s(r.name)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(r.roles, function (role) {
                                      return _c(
                                        "p",
                                        { staticClass: "text-muted" },
                                        [_vm._v(_vm._s(role.name_title))]
                                      )
                                    }),
                                  ],
                                  2
                                )
                              }),
                              _vm._v(" "),
                              _vm.data.status === 2
                                ? _c(
                                    "div",
                                    { staticClass: "form-group mt-1" },
                                    [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.toChiefRunner,
                                              expression: "toChiefRunner",
                                            },
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.toChiefRunner
                                            )
                                              ? _vm._i(
                                                  _vm.toChiefRunner,
                                                  null
                                                ) > -1
                                              : _vm.toChiefRunner,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = _vm.toChiefRunner,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.toChiefRunner =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.toChiefRunner = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.toChiefRunner = $$c
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          " Отправить старшему курьеру\n                  "
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _vm.$can("runner/orders/calls/details")
              ? _c("div", { staticClass: "mb-1" }, [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Информация по клиенту"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row client_info_block flex-nowrap" },
                    [
                      _c("div", { staticClass: "col-md-4" }, [
                        _c(
                          "div",
                          { staticClass: "message_div" },
                          [
                            _c("pulse-loader", {
                              staticClass: "text-center",
                              attrs: {
                                loading: _vm.orderDetailsLoading,
                                color: _vm.$constants.LOADING_COLOR,
                              },
                            }),
                            _vm._v(" "),
                            !_vm.orderDetailsLoading
                              ? [
                                  (_vm.orderDetails.phoneCalls ?? []).length
                                    ? [
                                        _c("p", [
                                          _vm._v("Всего звонков: "),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.orderDetails.phoneCalls
                                                  .length
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        !_vm.showPhoneCalls
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-xs btn-outline-info",
                                                on: {
                                                  click: function ($event) {
                                                    _vm.showPhoneCalls =
                                                      !_vm.showPhoneCalls
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "Показать звонки\n                    "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.showPhoneCalls
                                          ? _c(
                                              "div",
                                              { staticClass: "mb-1" },
                                              _vm._l(
                                                _vm.orderDetails.phoneCalls,
                                                function (call) {
                                                  return _c("div", [
                                                    _c(
                                                      "p",
                                                      { staticClass: "fs-12" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.printDate(
                                                              call.created_at,
                                                              "DD.MM.YYYY HH:mm"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    call.file_link
                                                      ? _c(
                                                          "audio",
                                                          {
                                                            attrs: {
                                                              controls: "",
                                                            },
                                                          },
                                                          [
                                                            _c("source", {
                                                              attrs: {
                                                                src: `/api/noa/mangoRecord/${call.id}`,
                                                                type: "audio/mpeg",
                                                              },
                                                            }),
                                                            _vm._v(
                                                              "\n                          Your browser does not support the audio tag.\n                        "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ])
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e(),
                                      ]
                                    : [
                                        _c("p", [
                                          _vm._v(
                                            "Нет звонков в системе по этому номеру"
                                          ),
                                        ]),
                                      ],
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c(
                          "div",
                          { staticClass: "message_div" },
                          [
                            _c("pulse-loader", {
                              staticClass: "text-center",
                              attrs: {
                                loading: _vm.orderDetailsLoading,
                                color: _vm.$constants.LOADING_COLOR,
                              },
                            }),
                            _vm._v(" "),
                            !_vm.orderDetailsLoading
                              ? [
                                  (_vm.orderDetails.history_orders ?? []).length
                                    ? _vm._l(
                                        _vm.orderDetails.history_orders,
                                        function (o) {
                                          return _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex justify-content-between mb-1 flex_gap_10 border-bottom",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex-grow-1 fs-12 align-self-center",
                                                },
                                                _vm._l(o.details, function (d) {
                                                  return _c("p", [
                                                    _vm._v(
                                                      _vm._s(d.drug.title)
                                                    ),
                                                  ])
                                                }),
                                                0
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "align-self-center",
                                                },
                                                [
                                                  _c("OrderStatus", {
                                                    attrs: { status: o.status },
                                                  }),
                                                  _vm._v(" "),
                                                  o.reject_comment
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "fs-12 text-muted",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              o.reject_comment
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "align-self-center",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "fs-12" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.printDate(
                                                            o.created_at,
                                                            "DD.MM.YYYY"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      )
                                    : [
                                        _vm._v(
                                          "\n                    Заявок по этому номеру телефона не найдены\n                  "
                                        ),
                                      ],
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c("p", { staticClass: "mb-0" }, [_vm._v("Текст сообщения:")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "message_div" },
                [
                  _c("div", { domProps: { innerHTML: _vm._s(_vm.message) } }),
                  _vm._v(" "),
                  _c("RunnerSalaryRate", {
                    attrs: { rate: _vm.data?.extra_options?.salary_rate ?? 0 },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.extra_message,
                    expression: "extra_message",
                  },
                ],
                staticClass: "form-control",
                attrs: { placeholder: "Текст сообщение или вопрос", rows: "5" },
                domProps: { value: _vm.extra_message },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.extra_message = $event.target.value
                  },
                },
              }),
            ]),
          ],
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-footer text-right" },
        [
          _c("LoadingButton", {
            attrs: {
              title: "Отправить",
              className: "btn btn-success btn-xs mb-1",
              onClick: _vm.sendMessage,
              loading: _vm.btnLoading,
              color: "white",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }